<style lang="scss" scoped>
.disabled-search {
    opacity: 0;
    pointer-events: none;
}
.nav-search-container {
    width: 250px;
    @media only screen and (min-width: 1200px) {
        width: 450px;
    }
    @media only screen and (min-width: 2000px) {
        width: 500px;
    }
}
.nav-search {
    transition: 0.2s background, 0.3s color;
    border: none;
    padding: 10px 45px 10px 15px;
    border-radius: 4px;
    width: 250px;
    @media only screen and (min-width: 1200px) {
        width: 450px;
    }
    @media only screen and (min-width: 2000px) {
        width: 500px;
    }

    & ~ .input-spyglass {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 1000;
    }
    &:focus,
    &.has-value {
        outline: none;
        box-shadow: none;
        background-color: #fff;

        &::placeholder {
            color: #283048 !important;
            opacity: 1;
        }

        &:-ms-input-placeholder {
            color: #283048 !important;
        }

        &::-ms-input-placeholder {
            color: #283048 !important;
        }
        & ~ .input-spyglass {
            .stroke {
                stroke: var(--secondary) !important;
            }
        }
    }
}
.search-results {
    position: absolute;
    top: 52px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    border: 1px solid #eeeff6;
    right: 0;
    left: 0;
    width: 250px;
    @media only screen and (min-width: 1200px) {
        width: 450px;
    }
    @media only screen and (min-width: 2000px) {
        width: 500px;
    }
    .search-items {
        margin: 0 -5px;
        width: calc(100% + 10px) !important;
        .title {
            padding: 0 5px;
        }
        .search-item {
            transition: 0.3s background;
            border-radius: 4px;
            cursor: pointer;
            padding: 5px;
            &:hover {
                background: rgba(40, 48, 72, 0.05);
            }
        }
    }
}
</style>

<template>
    <div>
        <div v-if="user" class="nav-search-container ml-auto mr-30 mr-xl-auto position-relative" :class="{ 'disabled-search' : disableSearch}">

            <input ref="normalSearch" class="nav-search fs-15 ff-l fw-n" v-model="searchValue" :class="{ 'has-value' : searchValue !== '', 'searchable-input' : showSearch }" type="text" :placeholder="$t('general.navbar.search_placeholder')" @input="handleSearch" @blur="() => { showSearch = false; }" @focus="showSearch = true" @keyup.enter="goTo({ name: 'search-show',  query: { q : searchValue } })" @keyup.down="selectNextItem" @keyup.up="selectPrevItem">

            <i-spyglass class="i-15 input-spyglass"></i-spyglass>

            <div class="p-30 bg-white search-results d-flex flex-column" v-if="showSearch" :class="{'searchable-input' : showSearch}" @mousedown.prevent>
                <div class="d-flex flex-row w-100 mb-15">
                    <p class="mb-0 fs-15 ff-l text-body">{{ $t('general.navbar.search_for', {value: searchValue, workspace: workspace.name}) }}</p>
                    <span class="ml-auto fs-11 my-auto text-body">{{ $t('general.navbar.press_enter') }}</span>
                </div>
                <div v-if="searching" class="d-flex mt-15">
                    <span class="mx-auto text-body fs-11 d-flex">
                        <i-loader class="i-15 loader-dark mr-15"></i-loader>{{$t('general.navbar.loading')}}
                    </span>
                </div>
                <div v-if="searchResults.results" class="d-flex flex-column w-100" :style="{ 'margin-bottom' : '-25px'}">

                    <!-- Containers -->
                    <div class="my-15 search-items" v-if="searchResults.containers && Object.keys(searchResults.containers).length > 0">
                        <p class="fs-15 fw-b ff-l mb-15 title">{{$t('general.navbar.containers')}}</p>
                        <a class="search-item fs-15 fw-n ff-l mb-5 text-secondary w-100 d-flex" :class="{ selected : false  }" href="#" @click="goTo({ name: 'container-show',  params: { containerId : container.id} })" v-for="container in searchResults.containers" :key="container.id">
                            <i-grid v-if="!container.floor_plan_id" class="i-15 mr-10 my-auto fill-primary"></i-grid>
                            <i-map v-else class="i-15 mr-10 my-auto fill-primary"></i-map>
                            {{ container.title }}
                        </a>
                        <router-link v-if="searchResults.containers_has_more" :to="{  name: 'search-show',  query: { q : searchValue }}" class="search-item d-flex w-100 fs-11 fw-n ff-l text-primary">
                            +{{ searchResults.containers_count }} {{$t('general.navbar.results')}}
                        </router-link>
                    </div>

                    <!-- Objects -->
                    <div class="w-100 my-15 search-items" v-if="searchResults.objects && Object.keys(searchResults.objects).length > 0">
                        <p class="fs-15 fw-b ff-l mb-15 title">{{$t('general.navbar.objects')}}</p>
                        <a class="search-item fs-15 fw-n ff-l mb-5 text-secondary w-100 d-flex" :class="{ selected : false }" href="#" @click="goTo({ name: 'object-show',  params: { objectId : object.id} })" v-for="object in searchResults.objects" :key="object.id">
                            <i-object class="i-15 mr-10 my-auto fill-primary"></i-object>
                            {{ object.title }}
                        </a>
                        <router-link v-if="searchResults.objects_has_more" :to="{  name: 'search-show',  query: { q : searchValue }}" class="search-item d-flex w-100 fs-11 fw-n ff-l text-primary">
                            +{{ searchResults.objects_count }} {{$t('general.navbar.results')}}
                        </router-link>
                    </div>

                    <!-- Files -->
                    <div class="w-100 my-15 search-items" v-if="searchResults.files && Object.keys(searchResults.files).length > 0">
                        <p class="fs-15 fw-b ff-l mb-1 title">{{$t('general.navbar.files')}}</p>
                        <a class="search-item fs-15 fw-n ff-l mb-5 text-secondary w-100 d-flex" :class="{ selected : false }" href="#" @click="goTo({ name: 'object-show',  params: { objectId : file.object_id }, query: { fileId: file.id } })" v-for="file in searchResults.files" :key="file.id">
                            <el-file-icon class="mr-10 my-auto" :file="file" size="small"></el-file-icon>
                            <span class="my-auto">{{ file.name }}</span>
                        </a>
                    </div>
                </div>
                <div v-else-if="!searching && !searchResults.results" class="d-flex fs-11 text-light">
                    <span class="mx-auto">{{$t('general.navbar.no_results')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { _ } from "vue-underscore";
import { mapActions } from "vuex";
import ClickOutside from "vue-click-outside";
import { ElFileIcon } from "@/components/elements/_index";

export default {
    directives: { ClickOutside },

    components: { ElFileIcon },

    props: {
        disableSearch: {
            default: false
        }
    },

    data() {
        return {
            searchValue: "",
            showSearch: false,
            searching: false,
            searchResults: {
                results: false,
                containers: {},
                objects: {},
                files: {}
            },
        };
    },

    created() {
        this.searchValue = this.$route.query.q;
    },
    methods: {
        ...mapActions(["search"]),

        showMobileSearch() {
            this.showSearch = !this.showSearch;
            if (this.showSearch)
                this.$nextTick().then(() => { this.$refs.mobileSearch.focus() })
        },

        goTo(route) {
            this.$router.push(route);
            this.showSearch = false;
            this.searchResults = {
                results: false,
                containers: {},
                objects: {},
                files: {}
            };
            if (this.$refs.mobileSearch) this.$refs.mobileSearch.blur();
            if (this.$refs.normalSearch) this.$refs.normalSearch.blur();
        },
        handleSearch: _.debounce(function() {
            if (this.searchValue !== "" && this.$route.name !== 'search-show') {
                this.searching = true;
                this.search({ workspaceId: this.workspace.id, search: this.searchValue }).then(res => {
                    this.showSearch = true;
                    this.searchResults = res;
                    this.searching = false;
                });
            } else {
                this.searchResults.results = false;
                this.showSearch = false;
            }
        }, 500)
    },
    computed: {
        user() {
            return this.$store.getters['auth/user']
        },
        workspace() {
            return this.$store.getters['workspace/current']
        },
        workspaces() {
            return this.$store.getters['workspace/all']
        }
    },
    watch: {
        '$route.path': function() {
            if (this.$route.name !== 'search-show')
                this.searchValue = "";
        }
    }
};
</script>